@if (image_small) {
  <div class="image-container">
    <button (click)="onImageClick()">
      <img [src]="image_small" loading="lazy" [style.width.px]="size" [style.height.px]="size" />
    </button>
  </div>
} @else {
  <div class="image-container">
    <div class="no-image" [style.width.px]="size" [style.height.px]="size">
      <mat-icon [style.width.px]="size / 2.5" [style.height.px]="size / 2.5" [style.font-size.px]="size / 2.5">hide_image</mat-icon>
    </div>
  </div>
}
